import _asyncToGenerator from "/home/jenkins/workspace/build-ccp-docs/mission-control/web/amplify-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _wrapAsyncGenerator from "/home/jenkins/workspace/build-ccp-docs/mission-control/web/amplify-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapAsyncGenerator";
import _awaitAsyncGenerator from "/home/jenkins/workspace/build-ccp-docs/mission-control/web/amplify-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/awaitAsyncGenerator";
import _asyncGeneratorDelegate from "/home/jenkins/workspace/build-ccp-docs/mission-control/web/amplify-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncGeneratorDelegate";
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(typeof e + " is not iterable"); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(r) { var n = this.s.return; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, throw: function _throw(r) { var n = this.s.return; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
export var streamChunk = /*#__PURE__*/_regenerator().m(function streamChunk(chunk, chunkSize) {
  var len, pos, end;
  return _regenerator().w(function (_context) {
    while (1) switch (_context.n) {
      case 0:
        len = chunk.byteLength;
        if (!(!chunkSize || len < chunkSize)) {
          _context.n = 2;
          break;
        }
        _context.n = 1;
        return chunk;
      case 1:
        return _context.a(2);
      case 2:
        pos = 0;
      case 3:
        if (!(pos < len)) {
          _context.n = 5;
          break;
        }
        end = pos + chunkSize;
        _context.n = 4;
        return chunk.slice(pos, end);
      case 4:
        pos = end;
        _context.n = 3;
        break;
      case 5:
        return _context.a(2);
    }
  }, streamChunk);
});
export var readBytes = /*#__PURE__*/function () {
  var _ref = _wrapAsyncGenerator(/*#__PURE__*/_regenerator().m(function _callee(iterable, chunkSize) {
    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, chunk, _t;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _iteratorAbruptCompletion = false;
          _didIteratorError = false;
          _context2.p = 1;
          _iterator = _asyncIterator(readStream(iterable));
        case 2:
          _context2.n = 3;
          return _awaitAsyncGenerator(_iterator.next());
        case 3:
          if (!(_iteratorAbruptCompletion = !(_step = _context2.v).done)) {
            _context2.n = 5;
            break;
          }
          chunk = _step.value;
          return _context2.d(_regeneratorValues(_asyncGeneratorDelegate(_asyncIterator(streamChunk(chunk, chunkSize)), _awaitAsyncGenerator)), 4);
        case 4:
          _iteratorAbruptCompletion = false;
          _context2.n = 2;
          break;
        case 5:
          _context2.n = 7;
          break;
        case 6:
          _context2.p = 6;
          _t = _context2.v;
          _didIteratorError = true;
          _iteratorError = _t;
        case 7:
          _context2.p = 7;
          _context2.p = 8;
          if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
            _context2.n = 9;
            break;
          }
          _context2.n = 9;
          return _awaitAsyncGenerator(_iterator.return());
        case 9:
          _context2.p = 9;
          if (!_didIteratorError) {
            _context2.n = 10;
            break;
          }
          throw _iteratorError;
        case 10:
          return _context2.f(9);
        case 11:
          return _context2.f(7);
        case 12:
          return _context2.a(2);
      }
    }, _callee, null, [[8,, 9, 11], [1, 6, 7, 12]]);
  }));
  return function readBytes(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var readStream = /*#__PURE__*/function () {
  var _ref2 = _wrapAsyncGenerator(/*#__PURE__*/_regenerator().m(function _callee2(stream) {
    var reader, _yield$_awaitAsyncGen, done, value;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          if (!stream[Symbol.asyncIterator]) {
            _context3.n = 2;
            break;
          }
          return _context3.d(_regeneratorValues(_asyncGeneratorDelegate(_asyncIterator(stream), _awaitAsyncGenerator)), 1);
        case 1:
          return _context3.a(2);
        case 2:
          reader = stream.getReader();
          _context3.p = 3;
        case 4:
          _context3.n = 5;
          return _awaitAsyncGenerator(reader.read());
        case 5:
          _yield$_awaitAsyncGen = _context3.v;
          done = _yield$_awaitAsyncGen.done;
          value = _yield$_awaitAsyncGen.value;
          if (!done) {
            _context3.n = 6;
            break;
          }
          return _context3.a(3, 8);
        case 6:
          _context3.n = 7;
          return value;
        case 7:
          _context3.n = 4;
          break;
        case 8:
          _context3.p = 8;
          _context3.n = 9;
          return _awaitAsyncGenerator(reader.cancel());
        case 9:
          return _context3.f(8);
        case 10:
          return _context3.a(2);
      }
    }, _callee2, null, [[3,, 8, 10]]);
  }));
  return function readStream(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
export var trackStream = function trackStream(stream, chunkSize, onProgress, onFinish) {
  var iterator = readBytes(stream, chunkSize);
  var bytes = 0;
  var done;
  var _onFinish = function _onFinish(e) {
    if (!done) {
      done = true;
      onFinish && onFinish(e);
    }
  };
  return new ReadableStream({
    pull: function () {
      var _pull = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(controller) {
        var _yield$iterator$next, _done, value, len, loadedBytes, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return iterator.next();
            case 1:
              _yield$iterator$next = _context4.v;
              _done = _yield$iterator$next.done;
              value = _yield$iterator$next.value;
              if (!_done) {
                _context4.n = 2;
                break;
              }
              _onFinish();
              controller.close();
              return _context4.a(2);
            case 2:
              len = value.byteLength;
              if (onProgress) {
                loadedBytes = bytes += len;
                onProgress(loadedBytes);
              }
              controller.enqueue(new Uint8Array(value));
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t2 = _context4.v;
              _onFinish(_t2);
              throw _t2;
            case 4:
              return _context4.a(2);
          }
        }, _callee3, null, [[0, 3]]);
      }));
      function pull(_x4) {
        return _pull.apply(this, arguments);
      }
      return pull;
    }(),
    cancel: function cancel(reason) {
      _onFinish(reason);
      return iterator.return();
    }
  }, {
    highWaterMark: 2
  });
};